import React from 'react';
import { MailIcon, PhoneIcon, MapPinIcon, LinkedinIcon, ArrowRightIcon } from 'lucide-react';
import { profile } from '../data/profile';
interface SiteFooterProps {
  onRequestBriefing: () => void;
}
export function SiteFooter({
  onRequestBriefing
}: SiteFooterProps) {
  const year = new Date().getFullYear();
  return <footer id="contact" className="scroll-mt-16 bg-navy" data-id="element-199" data-mp="3hhoi9v2jg729">
      <div className="mx-auto max-w-shell px-6 py-20 lg:px-10 lg:py-24" data-id="element-200" data-mp="3dgl37asbef23">
        <div className="grid gap-14 lg:grid-cols-[1.2fr_1fr] lg:gap-20" data-id="element-201" data-mp="3deruzr21zmrz">
          <div data-id="element-202" data-mp="38g6t7n75kv1f">
            <p className="text-[11px] font-semibold uppercase tracking-overline text-bronze-400" data-id="element-203" data-mp="38ggn3lvbjmce">
              Executive Contact
            </p>
            <h2 className="mt-5 max-w-xl font-serif text-3xl leading-tight text-white sm:text-4xl" data-id="element-204" data-mp="2yk3pwe0keqcw">
              Board nominations, joint-venture steering, and strategic capital
              advisory.
            </h2>
            <p className="mt-5 max-w-lg text-base leading-relaxed text-steel-300" data-id="element-205" data-mp="wta95neuc33b">
              Inquiries from boards, institutional owners, and contractor
              leadership are reviewed directly.
            </p>
            <button type="button" onClick={onRequestBriefing} className="focus-ring group mt-9 inline-flex items-center gap-2 rounded-sm bg-white px-7 py-4 text-sm font-semibold text-navy transition-colors duration-150 ease-exec hover:bg-canvas" data-id="element-206" data-mp="1arj6m6nvy2jg">
              Request Executive Advisory / Board Briefing
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-exec group-hover:translate-x-1" aria-hidden="true" data-id="element-207" data-mp="1tgpkngdqi5yx" />
            </button>
          </div>

          <div className="lg:border-l lg:border-white/15 lg:pl-16" data-id="element-208" data-mp="1jpbpfkstfsbl">
            <h3 className="text-[11px] font-semibold uppercase tracking-overline text-bronze-400" data-id="element-209" data-mp="27fp7qjllmcsz">
              Conroy Advisory Group, LLC
            </h3>
            <ul className="mt-7 space-y-5" data-id="element-210" data-mp="2c90hotlpj9p4">
              <li className="flex items-start gap-4" data-id="element-211" data-mp="2m3fr9feugmt8">
                <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-bronze-400" aria-hidden="true" data-id="element-212" data-mp="2m0tm1mffeje6" />
                <span className="text-sm text-white" data-id="element-213" data-mp="2h1qffxjss543">{profile.contact.address}</span>
              </li>
              <li className="flex items-start gap-4" data-id="element-214" data-mp="2d42jqsaa68b5">
                <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-bronze-400" aria-hidden="true" data-id="element-215" data-mp="2823h5kmd7ff9" />
                <a href={profile.contact.phoneHref} className="focus-ring rounded-sm text-sm text-white transition-colors duration-150 ease-exec hover:text-bronze-400" data-id="element-216" data-mp="2353hbrg3z8wl">
                  {profile.contact.phoneDisplay}
                </a>
              </li>
              <li className="flex items-start gap-4" data-id="element-217" data-mp="1pdyj8tse2ood">
                <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-bronze-400" aria-hidden="true" data-id="element-218" data-mp="1kdapi0crztqg" />
                <a href={`mailto:${profile.contact.email}`} className="focus-ring break-all rounded-sm text-sm text-white transition-colors duration-150 ease-exec hover:text-bronze-400" data-id="element-219" data-mp="1fer544dtyq07">
                  {profile.contact.email}
                </a>
              </li>
              <li className="flex items-start gap-4" data-id="element-220" data-mp="4ucviz5mjmui">
                <LinkedinIcon className="mt-0.5 h-4 w-4 shrink-0 text-bronze-400" aria-hidden="true" data-id="element-221" data-mp="4srz13zr1tu0" />
                <a href={profile.contact.linkedIn} target="_blank" rel="noreferrer noopener" className="focus-ring rounded-sm text-sm text-white transition-colors duration-150 ease-exec hover:text-bronze-400" data-id="element-222" data-mp="8tvdpn629jtn">
                  linkedin.com/in/thomasrconroy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-4 border-t border-white/15 pt-8 text-xs leading-relaxed text-steel-400 sm:flex-row sm:items-center sm:justify-between" data-id="element-223" data-mp="2pldc76g7q6bo">
          <p data-id="element-224" data-mp="2tk2m2p21l5qk">© {year} Conroy Advisory Group, LLC. All rights reserved.</p>
          <p className="max-w-xl sm:text-right" data-id="element-225" data-mp="2ai3i2ifmgu6n">
            Conroy Advisory Group, LLC provides strategic advisory services and
            does not perform construction, engineering, or architectural
            services. Figures reflect cumulative program values across a 35-year
            career.
          </p>
        </div>
      </div>
    </footer>;
}